import { render, staticRenderFns } from "./LinkAccount.vue?vue&type=template&id=19dbd990&"
import script from "./LinkAccount.vue?vue&type=script&lang=js&"
export * from "./LinkAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports